import { render } from "./AppAside.vue?vue&type=template&id=741d717d"
import script from "./AppAside.vue?vue&type=script&lang=js"
export * from "./AppAside.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jissjohnson/code/Bitwissend/gnaw-now-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__